import { cn } from '@/lib/utils';

export function Loader({ message, className, absolute }: { className?: string; message?: string; absolute?: boolean }) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className={cn(
        'flex flex-col items-center justify-center gap-4 p-6',
        absolute && 'absolute inset-0 flex items-center justify-center',
        className,
      )}
    >
      {/* Spinner */}
      <div aria-hidden className="size-16 animate-spin rounded-full border-8 border-gray-200 border-t-primary" />
      {/* Message */}

      {message}
    </div>
  );
}
